import { render, staticRenderFns } from "./SettingsIndexSourceCreate.vue?vue&type=template&id=d2338c4a&"
import script from "./SettingsIndexSourceCreate.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexSourceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports